import { Directive, ElementRef, Host, Input } from '@angular/core';
import { PlayerEvent } from '../../model/player-event';
import { PlayerComponent } from './player/player.component';

@Directive({
  selector: '[appVideoControl]'
})
export class VideoControlDirective {

  private event: PlayerEvent;

  @Input() set appVideoControl(event: PlayerEvent) {
    this.event = event;
    this.control(event);
  };

  private player: HTMLVideoElement;

  constructor(public el: ElementRef, @Host() public playerCmp: PlayerComponent) {
    this.player = this.el.nativeElement as HTMLVideoElement;
    this.setVideoPlayer();
  }

  control(event: PlayerEvent): void {
    switch (event) {
      case PlayerEvent.START: {
        this.player.play().catch(_error => {});
        break;
      }
      case PlayerEvent.STOP: {
        this.player.load();
        break;
      }
      case PlayerEvent.PAUSE: {
        this.player.pause();
        this.playerCmp.pauseTime.emit(this.player.currentTime);
        break;
      }
      default: break;
    }
  }

  private setVideoPlayer(): void {
    this.el.nativeElement.disablePictureInPicture = !this.playerCmp.remoteCotrolEnabled;
    this.el.nativeElement.disableRemotePlayback = !this.playerCmp.remoteCotrolEnabled;
    this.el.nativeElement.controlsList = `${!this.playerCmp.remoteCotrolEnabled ? 'noremoteplayback' : ''} nofullscreen nodownload`;
    this.player.volume = this.playerCmp.audioEnabled ? 0.8 : 0;
    this.player.onplay = this.controlFunction(PlayerEvent.START);
    this.player.onpause = this.controlFunction(PlayerEvent.PAUSE);
    this.player.onloadstart = () => this.player.autoplay = this.event === PlayerEvent.START;
  }

  private controlFunction(controlEvent: PlayerEvent): () => void {
    return () => {
      if (this.event !== controlEvent) {
        // prevents remote control if disabled
        if (!this.playerCmp.remoteCotrolEnabled)
          this.control(this.event);
        else {
          this.event = controlEvent;
        }
        this.playerCmp.currentEvent.emit(this.event);
      };
    };
  }
}
